import React from 'react';
import { HISTORY_COPY } from '../constants/sessionHistory';

/**
 * Marks a line, card or alert restored from the saved session: said before
 * this client joined or while it was reconnecting. Muted ink, like every
 * caption, so it reads as context and never as an alert.
 */
const EarlierTag: React.FC = () => (
  <span className="text-[11px] font-medium text-ink-muted" title={HISTORY_COPY.earlierDetail}>
    {HISTORY_COPY.earlier}
  </span>
);

export default EarlierTag;
